import React from 'react';

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';

export default function SnackBar(props) {

    return (
        <div className='snack-bar-container'>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={props.isOpen}
                onClose={() => props.handleChange('openSnackMsg', false)}
                autoHideDuration={6000}
                ContentProps={{
                    'aria-describedby': 'snack-bar-msg',
                }}
                message={<div className='snack-bar-msg-content'>
                    <span className='snack-bar-msg-icon'><InfoIcon></InfoIcon></span>
                    <span className="snack-bar-msg">{props.snackBarMsg}</span>
                </div>}
                action={[
                    <IconButton
                        key="close"
                        aria-label="close"
                        color="inherit"
                        className='snack-msg-close-icon'
                        onClick={() => props.handleChange('openSnackMsg', false)}>
                        <CloseIcon />
                    </IconButton>,
                ]} />
        </div>

    );
};